const assistConfig = [
  {
    key: "usd",
    name: "USD",
    note: "$",
    decimal: 2,
  },
  {
    key: "aed",
    name: "AED",
    note: "د.إ",
    decimal: 2,
  },
  {
    key: "sar",
    name: "SAR",
    note: "ر.س",
    decimal: 2,
  },
  {
    key: "brl",
    name: "BRL",
    note: "R$",
    decimal: 2,
  },
  {
    key: "vnd",
    name: "VND",
    note: "₫",
    decimal: 0,
  },
];

const publicFaceBook = "https://www.facebook.com/XT.comexchange";
const publicTwitter = "https://twitter.com/XTexchange";
const publicLinkedIn = "https://www.linkedin.com/company/xt-com-exchange/mycompany/";
const publicInstagram = "https://www.instagram.com/xt.com_exchange/";
const publicDiscord = "https://discord.com/invite/tcx84qXNW3";
const publicReddit = "https://www.reddit.com/r/XTExchange/";
const publicTiktok = "https://www.tiktok.com/@xt.com_exchange_id";
const publicYoutube = "https://www.youtube.com/channel/UCeiEo_mY82qbg5v0C22TyZA";
const publicTelegram = "https://t.me/XTsupport_EN";
const publicMedium = "https://medium.com/@XT_com";

const FacebookHref = {
  "zh-CN": publicFaceBook,
  "zh-HK": publicFaceBook,
  en: publicFaceBook,
  ko: publicFaceBook,
  ru: "https://www.facebook.com/xtcomrussia/",
  es: publicFaceBook,
  ar: "https://www.facebook.com/XT-Exchange-MENA-100327972635939",
  tr: "https://www.facebook.com/XT-T%C3%BCrkiye-105693355473171",
  hi: publicFaceBook,
  id: publicFaceBook,
  ja: publicFaceBook,
};

const TwitterHref = {
  "zh-CN": publicTwitter,
  "zh-HK": publicTwitter,
  en: publicTwitter,
  ko: "https://twitter.com/KoreanXt",
  ru: "https://twitter.com/xt_russian",
  es: "https://twitter.com/XT_Espanol",
  ar: "https://twitter.com/XtMena",
  tr: "https://twitter.com/XT_Turkey",
  hi: "https://twitter.com/XT_Hindi",
  id: publicTwitter,
  ja: publicTwitter,
};

const LinkedInHref = {
  "zh-CN": publicLinkedIn,
  "zh-HK": publicLinkedIn,
  en: publicLinkedIn,
  ko: publicLinkedIn,
  ru: publicLinkedIn,
  es: publicLinkedIn,
  ar: publicLinkedIn,
  tr: publicLinkedIn,
  hi: publicLinkedIn,
  id: publicLinkedIn,
  ja: publicLinkedIn,
};

const InstagramHref = {
  "zh-CN": publicInstagram,
  "zh-HK": publicInstagram,
  en: publicInstagram,
  ko: publicInstagram,
  ru: publicInstagram,
  es: publicInstagram,
  ar: "https://www.instagram.com/xt.com_mena/",
  tr: "https://www.instagram.com/xt_turkey/",
  hi: publicInstagram,
  id: "https://www.instagram.com/xt.com_exchange_indonesia/",
  ja: publicInstagram,
};

const DiscordHref = {
  "zh-CN": publicDiscord,
  "zh-HK": publicDiscord,
  en: publicDiscord,
  ko: publicDiscord,
  ru: "https://discord.gg/Wn7PPPpVqh",
  es: publicDiscord,
  ar: "https://discord.gg/qpAZAfY3eH",
  tr: publicDiscord,
  hi: publicDiscord,
  id: publicDiscord,
  ja: publicDiscord,
};

const RedditHref = {
  "zh-CN": publicReddit,
  "zh-HK": publicReddit,
  en: publicReddit,
  ko: publicReddit,
  ru: publicReddit,
  es: publicReddit,
  ar: publicReddit,
  tr: publicReddit,
  hi: publicReddit,
  id: publicReddit,
  ja: publicReddit,
};

const TiktokHref = {
  "zh-CN": publicTiktok,
  "zh-HK": publicTiktok,
  en: publicTiktok,
  ko: publicTiktok,
  ru: "http://www.tiktok.com/@xt.com_russia",
  es: publicTiktok,
  ar: publicTiktok,
  tr: publicTiktok,
  hi: publicTiktok,
  id: "https://www.tiktok.com/@xt.com_exchange_id",
  ja: publicTiktok,
};

const YoutubeHref = {
  "zh-CN": publicYoutube,
  "zh-HK": publicYoutube,
  en: publicYoutube,
  ko: publicYoutube,
  ru: publicYoutube,
  es: publicYoutube,
  ar: publicYoutube,
  tr: "https://www.youtube.com/channel/UC3JFzZvNz4r4gTHWsiOUIsg/featured",
  hi: publicYoutube,
  id: publicYoutube,
  ja: publicYoutube,
};

const TelegramHref = {
  "zh-CN": "https://t.me/XTsupport",
  "zh-HK": "https://t.me/XT_TCHN",
  en: publicTelegram,
  ko: publicTelegram,
  ru: "https://t.me/XT_Russia",
  es: publicTelegram,
  ar: "https://t.me/XT_Arabic",
  tr: "https://t.me/XT_Turkish",
  hi: publicTelegram,
  id: "https://t.me/XT_Indonesia",
  ja: publicTelegram,
};

const MediumHref = {
  "zh-CN": publicMedium,
  "zh-HK": publicMedium,
  en: publicMedium,
  ko: publicMedium,
  ru: publicMedium,
  es: publicMedium,
  ar: publicMedium,
  tr: publicMedium,
  hi: publicMedium,
  id: publicMedium,
  ja: publicMedium,
};
const connections = {
  FacebookHref,
  TwitterHref,
  LinkedInHref,
  InstagramHref,
  DiscordHref,
  RedditHref,
  TiktokHref,
  YoutubeHref,
  TelegramHref,
  MediumHref,
  publicFaceBook,
  publicTwitter,
  publicLinkedIn,
  publicInstagram,
  publicDiscord,
  publicReddit,
  publicTiktok,
  publicYoutube,
  publicTelegram,
  publicMedium,
};
export default {assistConfig,connections}
